export const permissionKeyByPermissionKey = {
  'general.excelExport': 'general.excelExport',
  'general.isAdmin': 'general.isAdmin',
  'modules.changelog': 'modules.changelog',
  'modules.debug': 'modules.debug',
  'modules.designerQueue': 'modules.designerQueue',
  'modules.familyAlbum': 'modules.familyAlbum',
  'modules.feedback': 'modules.feedback',
  'modules.groups': 'modules.groups',
  'modules.markedForDesigners': 'modules.markedForDesigners',
  'modules.myOrders': 'modules.myOrders',
  'modules.mySearches': 'modules.mySearches',
  'modules.requestedRugs': 'modules.requestedRugs',
  'modules.search': 'modules.search',
  'modules.settings': 'modules.settings',
  'modules.statistics': 'modules.statistics',
  'modules.status': 'modules.status',
  'modules.users': 'modules.users',
  'picture.action.downloadCropped': 'picture.action.downloadCropped',
  'picture.action.downloadDesigner': 'picture.action.downloadDesigner',
  'picture.action.downloadEmail': 'picture.action.downloadEmail',
  'picture.action.downloadOriginal': 'picture.action.downloadOriginal',
  'picture.action.downloadThumbnail': 'picture.action.downloadThumbnail',
  'picture.action.setAsPrimary': 'picture.action.setAsPrimary',
  'picture.action.uploadDesignerPicture': 'picture.action.uploadDesignerPicture',
  'picture.field.creator': 'picture.field.creator',
  'picture.field.dateScanned': 'picture.field.dateScanned',
  'picture.field.dateUpdated': 'picture.field.dateUpdated',
  'picture.field.pictureSource': 'picture.field.pictureSource',
  'picture.field.pictureTypes': 'picture.field.pictureTypes',
  'picture.picture.nonPrimary': 'picture.picture.nonPrimary',
  'picture.picture.qcPicture': 'picture.picture.qcPicture',
  'rug.action.deleteRequestDesignerPicture': 'rug.action.deleteRequestDesignerPicture',
  'rug.action.editReserve': 'rug.action.editReserve',
  'rug.action.isMasterpiece': 'rug.action.isMasterpiece',
  'rug.action.markForDesigners': 'rug.action.markForDesigners',
  'rug.action.requestDesignerPicture': 'rug.action.requestDesignerPicture',
  'rug.action.reserve': 'rug.action.reserve',
  'rug.field.advisor': 'rug.field.advisor',
  'rug.field.belCustomer': 'rug.field.belCustomer',
  'rug.field.belCustomerNb': 'rug.field.belCustomerNb',
  'rug.field.belNr': 'rug.field.belNr',
  'rug.field.belRgDate': 'rug.field.belRgDate',
  'rug.field.dateOrder': 'rug.field.dateOrder',
  'rug.field.dateReceipt': 'rug.field.dateReceipt',
  'rug.field.dateScanned': 'rug.field.dateScanned',
  'rug.field.dateUpdated': 'rug.field.dateUpdated',
  'rug.field.description': 'rug.field.description',
  'rug.field.edges': 'rug.field.edges',
  'rug.field.isMasterpiece': 'rug.field.isMasterpiece',
  'rug.field.markedForDesigners': 'rug.field.markedForDesigners',
  'rug.field.pictureCount': 'rug.field.pictureCount',
  'rug.field.price': 'rug.field.price',
  'rug.field.priceQm': 'rug.field.priceQm',
  'rug.field.producerCode': 'rug.field.producerCode',
  'rug.field.quality': 'rug.field.quality',
  'rug.field.requests': 'rug.field.requests',
  'rug.field.reservations': 'rug.field.reservations',
  'rug.field.rsvMenge': 'rug.field.rsvMenge',
  'rug.field.size': 'rug.field.size',
  'rug.field.status': 'rug.field.status',
  'rug.status.confirmed': 'rug.status.confirmed',
  'rug.status.inStock': 'rug.status.inStock',
  'rug.status.knotting': 'rug.status.knotting',
  'rug.status.onConsignment': 'rug.status.onConsignment',
  'rug.status.sold': 'rug.status.onConsignment',
  'rug.status.unknown': 'rug.status.onConsignment',
  'setting.additionalAdvisors': 'setting.additionalAdvisors',
  'setting.designerRequestNotifications': 'setting.designerRequestNotifications',
  'familyAlbum.downloadCustomerEmails': 'familyAlbum.downloadCustomerEmails',
  'familyAlbum.downloadOriginalPicture': 'familyAlbum.downloadOriginalPicture',
  'familyAlbum.setup': 'familyAlbum.setup',
  'users.editMode': 'users.editMode',
  'users.resetPassword': 'users.resetPassword',
}

export const permissionKeys = {
  general: {
    excelExport: {
      description: 'Users of this group are permitted to export their current search as an excel file.',
      name: 'Excel Export.',
      key: 'general.excelExport',
    },
    isAdmin: {
      description: 'Users of this group are administrators and are allowed to access everything.',
      name: 'Is Administrator.',
      key: 'general.isAdmin',
    },
  },
  modules: {
    changelog: {
      description: 'Users of this group are permitted to access the changelog.',
      name: 'Changelog',
      key: 'modules.changelog',
    },
    debug: {
      description: `Users of this group are permitted to access the 'Debug' module`,
      name: `Debug`,
      key: 'modules.debug',
    },
    designerQueue: {
      description: `Users of this group are permitted to access the 'Designer Queue' module`,
      name: `Designer Queue`,
      key: 'modules.designerQueue',
    },
    familyAlbum: {
      description: `Users of this group are permitted to access the 'Family Album' module`,
      name: `Family Album`,
      key: 'modules.familyAlbum',
    },
    feedback: {
      description: `Users of this group are permitted to send feedback.`,
      name: `Feedback`,
      key: 'modules.feedback',
    },
    groups: {
      description: `Users of this group are permitted to access the 'Groups' module and create/delete/edit group.`,
      name: 'Groups',
      key: 'modules.groups',
    },
    markedForDesigners: {
      description: `Users of this group are permitted to access the 'Marked for Designers' module.`,
      name: `Marked for Designers`,
      key: 'modules.markedForDesigners',
    },
    myOrders: {
      description: `Users of this group are permitted to access the 'My Orders' module.`,
      name: `My Orders`,
      key: 'modules.myOrders',
    },
    mySearches: {
      description: `Users of this group are permitted to access the 'Search' & My Searches' modules and can save their searches.`,
      name: `My Searches`,
      key: 'modules.mySearches',
    },
    requestedRugs: {
      description: `Users of this group are permitted to access the 'Requested Rugs' modules.`,
      name: `Requested Rugs`,
      key: 'modules.requestedRugs',
    },
    search: {
      description: `Users of this group are permitted to access the 'Search' module.`,
      name: `Search Rugs`,
      key: 'modules.search',
    },
    settings: {
      description: `Users of this group are permitted to access the 'Settings' module.`,
      name: `Settings`,
      key: 'modules.settings',
    },
    statistics: {
      description: `Users of this group are permitted to see the 'Statistics' on the 'Home' module.`,
      name: `Statistics`,
      key: 'modules.statistics',
    },
    status: {
      description: `Users of this group are permitted to access the 'Status' module.`,
      name: `Status`,
      key: 'modules.status',
    },
    users: {
      description: `Users of this group are permitted to access the 'Users' module and create/delete/edit users.`,
      name: `Users`,
      key: 'modules.users',
    },
  },
  picture: {
    action: {
      downloadCropped: {
        description: `Users of this group are permitted to download 'Cropped' pictures.`,
        name: 'Action: Download Cropped Pictures',
        key: 'picture.action.downloadCropped',
      },
      downloadDesigner: {
        description: `Users of this group are permitted to download 'Designer' pictures.`,
        name: 'Action: Download Designer Pictures',
        key: 'picture.action.downloadDesigner',
      },
      downloadEmail: {
        description: `Users of this group are permitted to download 'Email' pictures.`,
        name: 'Action: Download Email Pictures',
        key: 'picture.action.downloadEmail',
      },
      downloadOriginal: {
        description: `Users of this group are permitted to download 'Original' pictures.`,
        name: 'Action: Download Original Pictures',
        key: 'picture.action.downloadOriginal',
      },
      downloadOriginalRaw: {
        description: `Users of this group are permitted to download 'Original RAW' pictures.`,
        name: 'Action: Download Original RAW Pictures',
        key: 'picture.action.downloadOriginalRaw',
      },
      downloadThumbnail: {
        description: `Users of this group are permitted to download 'Thumbnail' pictures.`,
        name: 'Action: Download Thumbnail pictures',
        key: 'picture.action.downloadThumbnail',
      },
      setAsPrimary: {
        description: `Users of this group are permitted to set a picture as primary.`,
        name: 'Action: Set as Primary',
        key: 'picture.action.setAsPrimary',
      },
      uploadDesignerPicture: {
        description: `Users of this group are permitted to upload 'Designer' pictures.`,
        name: 'Action: Upload Designer Pictures',
        key: 'picture.action.uploadDesignerPicture',
      },
    },
    field: {
      creator: {
        description: `Users of this group are permitted to access the 'creator' field of pictures.`,
        name: 'Field: Creator',
        key: 'picture.field.creator',
      },
      dateScanned: {
        description: `Users of this group are permitted to access the 'Scan Date' field of pictures.`,
        name: 'Field: Scan Date',
        key: 'picture.field.dateScanned',
      },
      dateUpdated: {
        description: `Users of this group are permitted to access the 'Updated Date' field of pictures.`,
        name: 'Field: Updated Date',
        key: 'picture.field.dateUpdated',
      },
      pictureSource: {
        description: `Users of this group are permitted to access the 'Picture Source' field of pictures.`,
        name: 'Field: Picture Source',
        key: 'picture.field.pictureSource',
      },
      pictureTypes: {
        description: `Users of this group are permitted to access the 'Picture Type' field of pictures.`,
        name: 'Field: Picture Type',
        key: 'picture.field.pictureTypes',
      },
    },
    picture: {
      nonPrimary: {
        description: `Users of this group are permitted to see non-primary pictures.`,
        name: 'Pictures: Non-Primary',
        key: 'picture.picture.nonPrimary',
      },
      qcPicture: {
        description: `Users of this group are permitted to see quality-control pictures.`,
        name: 'Picturees: Quality-Control',
        key: 'picture.picture.qcPicture',
      },
    },
  },
  rug: {
    action: {
      isMasterpiece: {
        description: `Users of this group are permitted to mark a rug as a masterpiece`,
        name: 'Action: Mark as Masterpiece',
        key: 'rug.action.isMasterpiece',
      },
      markForDesigners: {
        description: `Users of this group are permitted to mark a rug for designers`,
        name: 'Action: Mark for Designers',
        key: 'rug.action.markForDesigners',
      },
      requestDesignerPicture: {
        description: `Users of this group are permitted to request 'Designer' pictures.`,
        name: 'Action: Request Designer Picture',
        key: 'rug.action.requestDesignerPicture',
      },
      deleteRequestDesignerPicture: {
        description: `Users of this group are permitted to delete requests for 'Designer' pictures.`,
        name: 'Action: Delete Designer Request Picture',
        key: 'rug.action.deleteRequestDesignerPicture',
      },
      reserve: {
        description: `Users of this group are permitted to reserve rugs.`,
        name: 'Action: Reserve Rug',
        key: 'rug.action.reserve',
      },
      editReserve: {
        description: `Users of this group are permitted to edit rug reservations.`,
        name: 'Action: Edit Rug Reservation',
        key: 'rug.action.editReserve',
      },
    },
    field: {
      advisor: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Advisor' field of rugs.`,
        name: 'Field: Advisor',
        key: 'rug.field.advisor',
      },
      belCustomer: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Customer' field of rugs.`,
        name: 'Field: Customer',
        key: 'rug.field.belCustomer',
      },
      belNr: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Invoice/On Consignment Number' field of rugs.`,
        name: 'Field: Invoice/On Consignment Number',
        key: 'rug.field.belNr',
      },
      belRgDate: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Invoice/On Consignment Date' field of rugs.`,
        name: 'Field: Invoice/On Consignment Date',
        key: 'rug.field.belRgDate',
      },
      dateOrder: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Order Date' field of rugs.`,
        name: 'Field: Order Date',
        key: 'rug.field.dateOrder',
      },
      dateReceipt: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Receipt Date' field of rugs.`,
        name: 'Field: Receipt Date',
        key: 'rug.field.dateReceipt',
      },
      dateScanned: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Scan Date' field of rugs.`,
        name: 'Field: Scan Date',
        key: 'rug.field.dateScanned',
      },
      dateUpdated: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Updated Date' field of rugs.`,
        name: 'Field: Updated Date',
        key: 'rug.field.dateUpdated',
      },
      description: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Description' field of rugs.`,
        name: 'Field: Description',
        key: 'rug.field.description',
      },
      edges: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Edges' field of rugs.`,
        name: 'Field: Edges',
        key: 'rug.field.edges',
      },
      isMasterpiece: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Marked as Masterpiece' field of rugs.`,
        name: 'Field: Marked as Masterpiece',
        key: 'rug.field.isMasterpiece',
      },
      markedForDesigners: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Marked for Designers' field of rugs.`,
        name: 'Field: Marked for Designers',
        key: 'rug.field.markedForDesigners',
      },
      pictureCount: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Picture Count' field of rugs.`,
        name: 'Field: Picture Count',
        key: 'rug.field.pictureCount',
      },
      pictureSource: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Picture Source' field of rugs.`,
        name: 'Field: Picture Source',
        key: 'rug.field.pictureSource',
      },
      price: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Price' field of rugs.`,
        name: 'Field: Price',
        key: 'rug.field.price',
      },
      priceQm: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Price (qm)' field of rugs.`,
        name: 'Field: Price (qm)',
        key: 'rug.field.priceQm',
      },
      producerCode: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Producer' field of rugs.`,
        name: 'Field: Producer',
        key: 'rug.field.producerCode',
      },
      quality: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Quality' field of rugs.`,
        name: 'Field: Quality',
        key: 'rug.field.quality',
      },
      requests: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Requests' field of rugs.`,
        name: 'Field: Requests',
        key: 'rug.field.requests',
      },
      reservations: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Reservations' field of rugs.`,
        name: 'Field: Reservations',
        key: 'rug.field.reservations',
      },
      rsvMenge: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Reserved Quantity' field of rugs.`,
        name: 'Field: Reserved Quantity',
        key: 'rug.field.rsvMenge',
      },
      size: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Size' field of rugs.`,
        name: 'Field: Size',
        key: 'rug.field.size',
      },
      status: {
        description: `Users of this group are permitted to access & (if allowed to use the Search Module) search for the 'Status' field of rugs.`,
        name: 'Field: Status',
        key: 'rug.field.status',
      },
    },
    status: {
      confirmed: {
        description: `Users of this group are permitted to see rugs that are confirmed.`,
        name: 'Confirmed',
        key: 'rug.status.confirmed',
      },
      inStock: {
        description: `Users of this group are permitted to see rugs that are in stock.`,
        name: 'In Stock',
        key: 'rug.status.inStock',
      },
      knotting: {
        description: `Users of this group are permitted to see rugs that are knotting.`,
        name: 'Knotting',
        key: 'rug.status.knotting',
      },
      onConsignment: {
        description: `Users of this group are permitted to see rugs that are on consignment.`,
        name: 'On Consignment',
        key: 'rug.status.onConsignment',
      },
      sold: {
        description: `Users of this group are permitted to see rugs that are sold.`,
        name: 'Sold',
        key: 'rug.status.sold',
      },
      unknown: {
        description: `Users of this group are permitted to see rugs that have an unknown status.`,
        name: 'Unknown',
        key: 'rug.status.unknown',
      },
    },
  },
  settings: {
    additionalAdvisors: {
      description: `Users of this group are permitted to set additional advisors in the settings modal. As long as their permitted to use the 'Settings' Module.`,
      name: 'Setting: Additional Advisors',
      key: 'setting.additionalAdvisors',
    },
    designerRequestNotifications: {
      description: `Users of this group are permitted to opt-out of designer request notifications. As long as their permitted to use the 'Settings' Module.`,
      name: 'Setting: Disable Designer Request Notifications',
      key: 'setting.designerRequestNotifications',
    },
  },
  familyAlbum: {
    downloadCustomerEmails: {
      description: `Users of this group are permitted to export an event's customer list. As long as their permitted to use the 'Family Album' Module.`,
      name: 'Download Customer Emails',
      key: 'familyAlbum.downloadCustomerEmails',
    },
    downloadOriginalPicture: {
      description: `Users of this group are permitted to download the original picture. As long as their permitted to use the 'Family Album' Module.`,
      name: 'Download Original Picture',
      key: 'familyAlbum.downloadOriginalPicture',
    },
    setup: {
      description: `Users of this group are permitted to setup an 'Family Album Event'. As long as their permitted to use the 'Family Album' Module.`,
      name: 'Setup',
      key: 'familyAlbum.setup',
    },
  },
  users: {
    editMode: {
      description: `Users of this group are permitted create, edit, and delete users. As long as their permitted to use the 'Users' Module.`,
      name: 'User Editting',
      key: 'users.editMode',
    },
    resetPassword: {
      description: `Users of this group are permitted to reset other user's password. As long as their permitted to use the 'Users' Module.`,
      name: 'Reset Password',
      key: 'users.resetPassword',
    },
  },
}
